<template>
  <div>
    <span class="badge badge-secondary" v-for="(image, field) in breakdownFilters">
      {{ names[field] }}: {{ sprintImage(image) }} <span class="times" @click="unselect(field)">&times;</span>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'Filters',
    props: {
      breakdownFilters: {type: Object, required: true},
      unselect: {type: Function, required: true},
    },
    data: function() {
      return {
        names: {
          'valLevel': 'Validation Level',
          'pubAlg': 'Public-Key Alg',
          'sigAlg': 'Signature Alg',
          'entryType': 'Entry Type',
          'expired': 'Status',
          'rootName': 'Root Authority',
        }
      }
    },
    methods: {
      sprintImage: function(image) {
        if (image.length > 3) {
          return '(several values)'
        }
        return image.join(', ')
      },
    },
  }
</script>

<style scoped>
  span.badge {
    padding: 5px;
    margin: 0px 0px 5px 5px;
  }
  span.times {
    cursor: pointer;
    margin-left: 3px;

    /* Prevent browser from asking to save/copy image. */
    -webkit-user-select: none;
    -webkit-touch-callout: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/Filters.vue